var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: ".88em",
    viewBox: "0 0 16 17",
    width: ".88em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3d3935"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.024 7.222c0-3.436 3.134-6.222 7-6.222s7 2.786 7 6.222c0 3.437-3.134 6.223-7 6.223a7.71 7.71 0 0 1-2.94-.58C3.632 13.64 1 15 1 15s1.559-3.876 1.323-4.17c-.817-1.017-1.3-2.262-1.3-3.608z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.893 4.89s0-1.556 1.826-1.556 1.803.956 1.803 2.512-1.803 1.377-1.803 2.932v.48M7.696 11.89v-1.855"
  }))));
};
export default SvgQuestion;